var _style, _g;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgEditar = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 75 75",
    style: {
      enableBackground: "new 0 0 75 75"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#517ED3;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.1,5.7V5h1.8v0.6c0,0.3,0.3,0.6,0.6,0.6h0.2c0.3,0,0.6-0.3,0.6-0.6V5h1.8v0.6c0,0.3,0.3,0.6,0.6,0.6H16 c0.3,0,0.6-0.3,0.6-0.6V5H17l1.2,1.2V8h1.3V5.7l-1.9-1.9h-0.9V3.1c0-0.3-0.3-0.6-0.6-0.6h-0.2c-0.3,0-0.6,0.3-0.6,0.6v0.6h-1.8V3.1 c0-0.3-0.3-0.6-0.6-0.6h-0.2c-0.3,0-0.6,0.3-0.6,0.6v0.6h-1.8V3.1c0-0.3-0.3-0.6-0.6-0.6H9.3C9,2.5,8.7,2.8,8.7,3.1v0.6H6.9V3.1 c0-0.3-0.3-0.6-0.6-0.6H6.1c-0.3,0-0.6,0.3-0.6,0.6v0.6h-3v18.7H8l0.3-1.2H3.8V5h1.7v0.6c0,0.3,0.3,0.6,0.6,0.6h0.2 c0.3,0,0.6-0.3,0.6-0.6V5h1.8v0.6C8.7,6,9,6.3,9.3,6.3h0.2C9.8,6.3,10.1,6,10.1,5.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.1,12l-2-2c-0.5-0.5-1.3-0.5-1.8,0c0,0,0,0,0,0l0,0l-7.3,7.3l-0.1,0.1l-1.3,5l5-1.3l0.5-0.5l0,0l7-7h0 c0,0,0,0,0,0C22.6,13.3,22.6,12.5,22.1,12z M11.4,18l2.8,2.8l-2.6,0.6l-0.8-0.8L11.4,18z M14.7,19l-1.6-1.6l5.2-5.2l1.6,1.6 L14.7,19z"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEditar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Editar.1a681584.svg";
export { ForwardRef as ReactComponent };